<template>
  <svg :width="width" :height="height" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M33.2947 28.0807C29.312 27.1502 27.0106 28.0619 27.0106 30.5933C27.0106 32.0773 27.8694 32.7275 30.1977 33.8197L30.5872 34.0033C32.0767 34.7161 32.5737 35.1152 32.5737 35.5181C32.5737 36.2655 31.9025 36.5999 30.3362 36.5751C29.7826 36.5663 29.1922 36.5078 28.5085 36.4068C28.323 36.3794 27.8468 36.3032 27.6967 36.279L27.5355 36.2604C27.0352 36.2411 26.5888 36.5995 26.51 37.1062C26.4252 37.652 26.7988 38.1631 27.3446 38.248C27.3093 38.2425 27.77 38.3167 28.0646 38.3623L28.6634 38.4473C29.2465 38.5224 29.7806 38.5665 30.3046 38.5748C32.8408 38.615 34.5737 37.7518 34.5737 35.5181C34.5737 33.9347 33.6591 33.2339 31.2167 32.0885L30.8353 31.9087C29.4695 31.2547 29.0106 30.8931 29.0106 30.5933C29.0106 29.7113 29.9278 29.3479 32.8396 30.0283C33.3774 30.1539 33.9152 29.8198 34.0409 29.282C34.1666 28.7442 33.8325 28.2064 33.2947 28.0807Z"
      :fill="color"
    />
    <path
      d="M37.0737 28.6743C37.5865 28.6743 38.0092 29.0603 38.067 29.5576L38.0737 29.6743V37.1743C38.0737 37.7265 37.626 38.1743 37.0737 38.1743C36.5609 38.1743 36.1382 37.7882 36.0804 37.2909L36.0737 37.1743V29.6743C36.0737 29.122 36.5214 28.6743 37.0737 28.6743Z"
      :fill="color"
    />
    <path
      d="M39.2808 23.9672C38.8903 23.5766 38.2571 23.5766 37.8666 23.9672L35.8666 25.9672L35.7834 26.0614C35.4784 26.4537 35.5061 27.0209 35.8666 27.3814C36.2571 27.7719 36.8903 27.7719 37.2808 27.3814L39.2808 25.3814L39.364 25.2872C39.669 24.8949 39.6413 24.3276 39.2808 23.9672Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.6884 18.8937C19.9452 20.3355 16.6407 24.8277 16.0415 31.8324L16.0201 32.1253C15.7224 37.081 18.7326 40.9392 24.8337 43.6383L25.3185 43.846L25.3186 51.3056L25.3242 51.4157C25.4064 52.2056 26.3646 52.6009 26.9818 52.054L35.8725 44.175L40.9922 44.176C42.492 44.176 45.0091 43.0526 46.9608 41.3293C49.5769 39.0193 51.1399 35.8385 51.1399 31.9177C51.1399 24.6629 47.8107 20.6694 42.5562 18.9027C38.9811 17.7006 28.6139 17.7006 24.6884 18.8937ZM41.9188 20.7984C46.4076 22.3076 49.1399 25.5851 49.1399 31.9177C49.1399 35.2392 47.8398 37.8851 45.637 39.8301C44.0254 41.2531 41.9575 42.176 40.9922 42.176H35.4929L35.3716 42.1833C35.1714 42.2078 34.9821 42.2925 34.8297 42.4275L27.3185 49.083L27.3186 43.176C27.3186 42.7658 27.0682 42.3973 26.6869 42.2463C20.4524 39.7767 17.659 36.3881 18.0342 32.0029C18.5666 25.7793 21.3468 21.9998 25.27 20.8073C28.7223 19.758 38.2786 19.733 41.681 20.7241L41.9188 20.7984Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'MultilingualIcon',
  props: {
    width: {
      type: Number,
      default: 64,
    },
    height: {
      type: Number,
      default: 64,
    },
    color: {
      type: String,
      default: '#4B4C52',
    },
  },
};
</script>
